import React from 'react';

import { makeStyles } from '@mui/styles';
import { PrevButton, NextButton } from 'components/wizard';

interface FooterProps {
    onNext: () => void;
    onPrev: () => void;
    hasInsertedCash: boolean;
}


const useStyles = makeStyles({
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        marginTop: '7vh',
    },
});

const PaymentFooter: React.FC<FooterProps> = (({ onNext, onPrev, hasInsertedCash }) => {
    const classes = useStyles();

    return (
        <div className={classes.footer}>
            <PrevButton
                buttonProps={{
                    style: {
                        visibility: hasInsertedCash
                            ? 'hidden'
                            : 'visible',
                    },
                    onClick: onPrev,
                }} />
            {hasInsertedCash && (
                <NextButton
                    buttonProps={{
                        onClick: onNext,
                    }}
                />
            )}
        </div>
    );
});

export default (PaymentFooter);